// Agency mode (draft 13): deals, tasks, projects and results. The agency's Home, Clients and Proposals sit with those areas.
import { Deals, Projects, Results, Tasks } from "../../screens/Agency";
import { AgencyOnly, Allowed, page } from "./base";

export const agencyRoutes = [
  // Agency mode (draft 13).
  page("/deals", () => (
    <Allowed action="lead.read">
      <AgencyOnly>
        <Deals />
      </AgencyOnly>
    </Allowed>
  )),
  page("/tasks", () => (
    <Allowed action="client.read">
      <AgencyOnly>
        <Tasks />
      </AgencyOnly>
    </Allowed>
  )),
  page("/projects", () => (
    <Allowed action="job.read">
      <AgencyOnly>
        <Projects />
      </AgencyOnly>
    </Allowed>
  )),
  page("/results", () => (
    <Allowed action="client.read">
      <AgencyOnly>
        <Results />
      </AgencyOnly>
    </Allowed>
  )),
] as const;
